// Saved compliance is independent of this device's permission.
export function retainDojoDeviceSetup(previous, dojo, data) {
  if (!requiresDevicePosition(data?.requirements) && !(previous?.setupRetained && previous.dojoId === dojo._id)) return null;
  return {
    ...data.compliance,
    dojoId: dojo._id,
    dojoName: dojo.name,
    requirements: data.requirements,
    violations: data.compliance.violations,
    refreshError: false,
    setupRetained: previous?.dojoId === dojo._id && previous?.setupRetained === true
  };
}

const audiences = ['public', 'dojo', 'dojo_chief', 'friends'];
export function requiresDevicePosition(requirements) {
  const position = requirements?.privacy?.position;
  return requirements?.location_capture_enabled === true ||
    (Array.isArray(position) ? position.some(value => audiences.includes(value)) : audiences.includes(position));
}
